import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffCrudReport = () => import('./staff/crudReport')
const ViewStaffCrudReportSeller = () => import('./staff/crudReportSeller')
const ViewStaffDetailReport = () => import('./staff/detailReport')

Vue.use(Router)

const router =
  [
    {
      path: '/st/reports-news',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: 'ReportsNewsStaffDashboard',
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
        },        
        {
          path: 'crud',
          name: 'ReportsNewsStaffCrudReport',
          component: ViewStaffCrudReport,
          beforeEnter: Permisos.IS_PERSONAL,
        },  
        {
          path: 'crud/customers/:customersID',
          name: 'ReportsNewsStaffCrudReportByCustomers',
          component: ViewStaffCrudReport,
          beforeEnter: Permisos.IS_PERSONAL,
        },          
        {
          path: 'crud-seller',
          name: 'ReportsNewsStaffCrudReportSeller',
          component: ViewStaffCrudReportSeller,
          beforeEnter: Permisos.IS_PERSONAL,
        },      
        {
          path: 'crud-seller/customers/:customersID',
          name: 'ReportsNewsStaffCrudReportSellerByCustomers',
          component: ViewStaffCrudReportSeller,
          beforeEnter: Permisos.IS_PERSONAL,
        },                
        {
          path: 'detail/:reportID/view',
          name: 'ReportsNewsStaffDetailReport',
          component: ViewStaffDetailReport,
          beforeEnter: Permisos.IS_PERSONAL,
        },
      ]
    },

    {
      path: '/cu/reports-news',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/reports-news',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
